import type { AppMode, ModeChangeEvent } from './types';

type ModeListener = (event: ModeChangeEvent) => void;

export class ModeManager {
  private _current: AppMode = 'play';
  private listeners: ModeListener[] = [];

  get current(): AppMode {
    return this._current;
  }

  switchTo(mode: AppMode): void {
    if (mode === this._current) return;
    const event: ModeChangeEvent = { from: this._current, to: mode };
    this._current = mode;
    this.listeners.forEach(fn => fn(event));
  }

  onChange(fn: ModeListener): void {
    this.listeners.push(fn);
  }
}
